export default __webpack_public_path__ + "static/media/wash.b891a3ef.PNG";